var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"currentColor","points":"12,6 7.6,11 6.8,10.3 10.2,6.5 0,6.5 0,5.5 10.2,5.5 6.8,1.7 7.6,1 "}));
}

ArrowInline.defaultProps = {"version":"1.1","id":"Layer_1","viewBox":"0 0 12 12"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
